import { createFileRoute } from '@tanstack/react-router';

import { MenusPage, menusQueryOptions } from '@/features/menus';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/menus/')({
  staticData: { tours: ['content.menus'] },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...menusQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: MenusPage,
});
